
<template>
  <div>
    <div class="box box-primary">
      <div class="box-header">
          <h3 class="box-title" style="text-transform: capitalize;">Thông tin cấp thẻ cư dân</h3>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-md-3 mb-10" v-for="(card, index) in cards" :key="index">
            <div class="resident-item">
              <!-- <img class="profile-user-img img-responsive img-circle" src="../../dist/img/user4-128x128.jpg" alt="User profile picture"> -->

              <h3 class="profile-username text-center" style="height:50px;">{{card.name}}</h3>

              <p class="text-muted text-center">{{$t(`customer.relationship.${card.position}`)}}</p>

              <ul class="list-group list-group-unbordered">
                <li class="list-group-item">
                  <b>{{$t(`customer.card.card_number`)}}</b> <a class="pull-right">{{card.card_number}}</a>
                </li>
                <li class="list-group-item">
                  <b>{{$t(`customer.relatives.identification_number`)}}</b> <a class="pull-right">{{card.identificationnumber}}</a>
                </li>
                <li class="list-group-item">
                  <b>{{$t(`customer.relatives.passport`)}}</b> <a class="pull-right">{{card.passport}}</a>
                </li>
                <li class="list-group-item">
                  <b>{{$t(`customer.card.date_registered`)}}</b> <a class="pull-right">{{card.date_registered}}</a>
                </li>
                <li class="list-group-item">
                  <b>{{$t(`customer.card.date_sent`)}}</b> <a class="pull-right">{{card.date_sent}}</a>
                </li>
                <li class="list-group-item">
                  <b>{{$t(`customer.card.card_status`)}}</b>
                  <a class="pull-right">
                    <span class="label label-primary" v-if="card.card_status==CardStatusEnum.UNREGISTERED">{{$t('customer.card.unregistered')}}</span>
                    <span class="label label-warning" v-else-if="card.card_status==CardStatusEnum.REGISTERED">{{$t('customer.card.registered')}}</span>
                    <span class="label label-success" v-else>{{$t('customer.card.completed')}}</span>
                  </a>
                </li>
              </ul>

              <a class="btn btn-primary btn-block" @click="onRegister(card)" v-if="card.card_status==CardStatusEnum.UNREGISTERED"><b>Đăng Ký Thẻ</b></a>
              <a class="btn btn-warning btn-block" @click="onComplete(card)" v-else-if="card.card_status==CardStatusEnum.REGISTERED"><b>Hoàn Tất</b></a>
              <a class="btn btn-success btn-block" @click="onComplete(card)" v-else><b>Sửa Thông Tin Thẻ</b></a>
            </div>
          </div>
        </div>

      </div>
      <div class="box-footer">
      </div>
    </div>
    <!-- Modal Relative Input -->
    <div class="modal fade" :ref="`modal-customer-card-input`">
      <div class="modal-dialog modal-lg">
        <ResidentCardInput
          :id="card_data.id"
          @card-save="onSaveCard"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
import ResidentCardInput from './ResidentCardInput'
import CardStatusEnum from "@/enum/cardStatusEnum";
import utils from '@/lib/utils'

export default {
  name: "ResidentCards",
  props: {
    id: {
      type: Number,
      default: () => { return 0 }
    },
  },
  data() {
    return {
      CardStatusEnum: CardStatusEnum,
      card_data: {
        id: 0
      },
    }
  },
  watch: {
    id: function() {
      if (this.id !== 0) {
        this.getCardsList()
      } else {
        // pass
      }
    }
  },
  computed: {
    ...mapGetters([
      "CARDS_LIST"
    ]),
    dateViewOptions: function(){
      return sessionStorage.getItem('projectDateViewOptions')
    },
    cards: function(){
      let cards = []
      this.CARDS_LIST.forEach(card => {
        let item = {
          id: card.id,
          card_number: card.card_number,
          card_status: card.card_status,
          date_registered: utils.formatSqlDate(card.date_registered, null, this.dateViewOptions),
          date_sent: utils.formatSqlDate(card.date_sent, null, this.dateViewOptions),
          identificationnumber: card.identificationnumber,
          name: card.name,
          passport: card.passport,
          position: card.position,
          resident_relative: card.resident_relative
        }
        cards.push(item)
      })
      this.$emit('cards', cards)
      return cards
    }
  },
  methods: {
    ...mapActions([
      "GET_CARDS_LIST",
      "ADD_CARD",
      "UPDATE_CARD",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST"
    ]),
    onToggleModalInput: function(action="show") {
      $(this.$refs[`modal-customer-card-input`]).modal(action)
    },
    getCardsList: function(data){
      if (this.id == 0){ return }
      const payload = {
        params: {
          user: this.id
        }
      }
      this.GET_CARDS_LIST(payload)
    },
    onComplete: function(card){
      this.card_data.id = card.id
      this.onToggleModalInput()
    },
    onRegister: function(card){
      const data = {
        user: this.id,
        resident_relative: card.resident_relative,
        card_number: card.card_number,
        date_registered: null,
        date_sent: null,
        card_accquired_from: card.card_accquired_from,
        card_status: CardStatusEnum.REGISTERED
      }
      if (!card.id) {
        this.ADD_CARD({data: data})
          .then(
            function() {
              this.SUCCESS_TOAST()
              this.getCardsList()
            }.bind(this)
          )
          .catch(
            function(error){
              this.ON_SHOW_TOAST({
                message: "Cần chứng minh thư hoặc hộ chiếu để cấp thẻ cư dân.",
                styleType: "danger"
              });
            }.bind(this)
          )
      } else {
        this.UPDATE_CARD({id: card.id, data: data})
          .then(
            function() {
              this.SUCCESS_TOAST()
              this.getCardsList()
            }.bind(this)
          )
          .catch(
            function(error){
              this.ON_SHOW_TOAST({
                message: "Cần chứng minh thư hoặc hộ chiếu để cấp thẻ cư dân.",
                styleType: "danger"
              });
            }.bind(this)
          )
      }
    },
    onSaveCard: function(id, card){
      const data = {
        user: card.user,
        resident_relative: card.resident_relative,
        card_number: card.card_number,
        date_registered: card.date_registered,
        date_sent: card.date_sent,
        card_accquired_from: card.card_accquired_from,
        card_status: card.card_status
      }
      this.UPDATE_CARD({id: id, data: data})
        .then(
          function() {
            this.onToggleModalInput("hide")
            this.SUCCESS_TOAST()
            this.getCardsList()
          }.bind(this)
        )
        .catch(
          function(error){
            this.ON_SHOW_TOAST({
              message: "Cần chứng minh thư hoặc hộ chiếu để cấp thẻ cư dân.",
              styleType: "danger"
            });
          }.bind(this)
        )
    }
  },
  mounted() {
    this.getCardsList()
  },
  components: {
    ResidentCardInput
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.resident-item {
  padding: 10px;
  border-top: 3px solid #d2d6de;
  box-shadow: 0 1px 1px rgba(0,0,0,0.1);
  border-top-color: #50bc3c;
}

.mb-10 {
  margin-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// src/views/Customer/ResidentCards.vue